import { httpClient, httpConfig } from 'utils/httpClient';
const URL = process.env.REACT_APP_API_URL;

const getQueryParams = (params: any) => {
  const queryParams = {};

  for (const param in params) {
    const paramValue = params[param];
    if (Array.isArray(paramValue) && paramValue.length) {
      paramValue.forEach((item, index) => {
        const paramName = `${param}[${index}]`;
        queryParams[paramName] = item;
      });
    } else if (!Array.isArray(paramValue) && paramValue) {
      queryParams[param] = String(paramValue);
    }
  }

  return queryParams;
};

export const searchCompanies = async (
  lang: string,
  search: string,
  legalForm: number[],
  activity: string[],
  ateRegions: string[],
  ateCity: string[],
  isLog: boolean
) => {
  const url = `${URL}/api/${isLog ? 'pv-' : ''}getcompanies`;

  const queryParams = getQueryParams({
    lang,
    search,
    legal_form: legalForm,
    economic_activity: activity,
    ate_1: ateRegions,
    ate_2: ateCity,
  });
  const res = await httpClient.post(
    url,
    new URLSearchParams(queryParams),
    httpConfig
  );

  return res.data.data;
};
